import Cookies from 'js-cookie';

const INITIAL_UTM_PARAMS_COOKIE = 'initial-utm-params';

export const getInitialUTMTraits = (): Record<string, string> => {
  if (typeof window === 'undefined') {
    return {};
  }

  try {
    const cookie = Cookies.get(INITIAL_UTM_PARAMS_COOKIE);

    if (!cookie) {
      return {};
    }

    const parsed: unknown = JSON.parse(cookie);

    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return {};
    }

    const result: Record<string, string> = {};

    for (const [key, value] of Object.entries(parsed)) {
      if (key.startsWith('initial_utm_') && value !== null && value !== undefined && value !== '') {
        result[key] = String(value);
      }
    }

    return result;
  } catch {
    return {};
  }
};
